import React from 'react';

interface BannerImageProps {
    imageUrl?: string | null;
    alt?: string;
    productName?: string;
}

const BannerImage: React.FC<BannerImageProps> = ({
    imageUrl = null,
    alt = "Banner do Checkout",
    productName = ""
}) => {
    // Se não tiver imagem, mostra o título do produto
    if (!imageUrl) {
        if (productName) {
            return (
                <div className="flex justify-center">
                    <div className="w-full max-w-3xl py-8">
                        <h1 className="ms-3 text-2xl font-bold text-gray-800">{productName}</h1>
                    </div>
                </div>
            );
        }
        return null;
    }

    // Renderização simples da imagem seguindo o padrão Kiwify
    return (
        <div className="relative w-full flex justify-center p-2">
            <div className="flex w-full justify-center">
                <div className="w-full">
                    <img
                        src={imageUrl}
                        alt={alt || productName}
                        loading="lazy"
                        className="w-full"
                        style={{
                            maxWidth: '100%',
                            height: 'auto'
                        }}
                    />
                </div>
            </div>
        </div>
    );
};

export default BannerImage;